import React from 'react'
import './Experience.css'

const Experience = () => {
  return (
    <div className="experience" id='Experience'>
        <div className="achievement">
        
            <div className="circle">2+</div>
            <span>years</span>
            <span>Experience</span>
        </div>
        <div className="achievement">
            <div className="circle">10+</div>
            <span>project</span>
            <span>Completed</span>
        </div>
        <div className="achievement">
            <div className="circle">1+</div>
            <span>Company</span>
            <span>Workedin</span>
        </div>
    </div>
  )
}

export default Experience